import { render, staticRenderFns } from "./SignupThanks.vue?vue&type=template&id=2b73d064&"
import script from "./SignupThanks.vue?vue&type=script&lang=js&"
export * from "./SignupThanks.vue?vue&type=script&lang=js&"
import style0 from "./SignupThanks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports